import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, IconButton, TextField, Typography } from '@mui/material';
import { Check, Close, EditOutlined } from '@mui/icons-material';
import palette from '@theme/palette';
/** A text value that reveals an edit affordance on hover and commits changes on confirm. */
export function InlineEditText({ value, onSave, placeholder, multiline, allowEmpty, typographySx }) {
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState(value);
    useEffect(() => {
        setDraft(value);
    }, [value]);
    const commit = () => {
        const trimmed = draft.trim();
        // Required field: discard the empty edit instead of silently keeping it as a draft that
        // would reappear (still empty) the next time the editor opens.
        if (!trimmed && !allowEmpty) {
            cancel();
            return;
        }
        if (trimmed !== value) {
            onSave(trimmed);
        }
        setEditing(false);
    };
    const cancel = () => {
        setDraft(value);
        setEditing(false);
    };
    if (editing) {
        return (_jsxs(Box, { display: "flex", alignItems: "center", gap: 0.5, width: "100%", children: [_jsx(TextField, { value: draft, onChange: e => setDraft(e.target.value), size: "small", fullWidth: true, autoFocus: true, multiline: multiline, onKeyDown: e => {
                        if (e.key === 'Enter' && !multiline)
                            commit();
                        if (e.key === 'Escape')
                            cancel();
                    }, inputProps: { style: { fontSize: '14px' } } }), _jsx(IconButton, { size: "small", color: "primary", onClick: commit, "aria-label": "save", children: _jsx(Check, { fontSize: "small" }) }), _jsx(IconButton, { size: "small", onClick: cancel, "aria-label": "cancel", children: _jsx(Close, { fontSize: "small" }) })] }));
    }
    return (_jsxs(Box, { display: "flex", alignItems: "center", gap: 1, sx: { '&:hover .inline-edit-icon': { opacity: 1 } }, children: [_jsx(Typography, { sx: Object.assign({ color: value ? undefined : palette.neutral[60] }, typographySx), children: value || placeholder }), _jsx(IconButton, { className: "inline-edit-icon", size: "small", sx: { opacity: 0, transition: 'opacity 0.15s ease' }, onClick: () => setEditing(true), "aria-label": "edit", children: _jsx(EditOutlined, { sx: { fontSize: '16px' } }) })] }));
}
